module.exports = __webpack_public_path__ + "images/dinersClub-3DICi7a.svg";